import FooterCodes from '@/utils/footer-codes'

export const footerShopInfosProps = () => ({
  eligibleLad: {
    type: Boolean,
    required: false,
    default: false
  },
  isFidCarrefour: {
    type: Boolean,
    required: false,
    default: false
  }
})

export const footerShopInfosEmits = () => ([
  "openStoreLocator"
])
export const useFooterShopInfos = (props, context) => {

  const route = useRoute();

  const aide = [
    { type: "link", title: "Aide", href: FooterCodes.HELP },
    { type: "link", title: "Recrutement", href: "https://recrute.carrefour.fr/", target: "_blank" },
    { type: "link", title: "Contactez le SAV", href: FooterCodes.GUARANTEE_AND_SAV },
    { type: "link", title: "Contactez-nous", href: FooterCodes.CONTACT },
    { type: "link", title: "Espace sourds et malentendants", href: FooterCodes.DEAF_SPACE, target: "_blank" }
  ]

  let fidelite

  if(props.isFidCarrefour) {
    fidelite = [
      { type: "link", title: "Le Programme de Fidélité Carrefour", href: FooterCodes.LOYALTY_CARREFOUR_PROGRAM },
      { type: "link", title: "Les avantages de la Carte PASS", href: "https://www.carrefour.fr/services/carte-pass", target: "_blank" }
    ]
  } else {
    fidelite = [
      { type: "link", title: "Le programme de fidélité", href: FooterCodes.LOAYALTY_PROGRAM },
      { type: "link", title: "Les avantages de la carte Cora", href: FooterCodes.CORA_CARDS },
      { type: "link", title: "Formulaire de résiliation", href: FooterCodes.RESILIATION_FORM }
    ]
  }

  const responsable = [
    { type: "link", title: "Ligne d'alerte éthique", href: "https://secure.ethicspoint.eu/domain/media/fr/gui/102586/index.html", target: "_blank" },
    { type: "link", title: "RSE", href: "https://cora-france.fr/le-developpement-durable", target: "_blank" }
  ]
  const donneesPersonnelle = [
    { type: "link", title: "Politique données personnelles - Clients internet", href: FooterCodes.PERSONAL_DATA_POLICY },
    { type: "link", title: "Politique données personnelles - Programme de fidélité", href: FooterCodes.PERSONAL_DATA_POLICY_FIDELITY },
    { type: "link", title: "Politique données personnelles - Services pro", href: FooterCodes.PERSONAL_DATA_CORAPRO },
    { type: "link", title: "Données Personnelles - Exercez vos droits", href: FooterCodes.PERSONAL_DATA, target: "_blank" },
    { type: "oneTrust", title: "Préférence des cookies" }
  ]

  if(!props.isFidCarrefour) {
    donneesPersonnelle.splice(1, 0, { type: "link", title: "Politique données personnelles - Programme de fidélité", href: FooterCodes.PERSONAL_DATA_LOAYALTY },)
  }

  const servicePro = [
    { type: "link", title: "Découvrir nos Services pro", href: FooterCodes.DISCOVER_CORA_PRO },
    { type: "link", title: "Drive Services pro", href: FooterCodes.CORA_PRO_SERVICES },
    { type: "link", title: "Demandez vos accès", href: FooterCodes.REQUEST_ACCESS }
  ]
  const serviceLivraison = [
    { type: "link", title: "Découvrir les services de retrait et livraison", href: FooterCodes.SHIPPING_SERVICES }
  ]
  const rappelProduit = [
    { type: "link", title: "Voir tous les rappels produits", href: FooterCodes.PRODUCT_REMINDER }
  ]

  const showBanners = computed(() => {
    return route.path === "/"
  });
  const magasin = computed(() => {
    let magasin = [
      { type: "link", title: "En ce moment", href: FooterCodes.IN_THIS_MOMENT },
      { type: "link", title: "Accès et horaires", href: `/magasins/${props.webAlias}-m-${props.shopId}`, storeLoc: props.isNational, redirect: true },
      { type: "link", title: "Prospectus", href: FooterCodes.PROSPECTUS },
      { type: "link", title: "Changer de magasin", storeLoc: true },
      { type: "link", title: "Liste des magasins", href: FooterCodes.SHOP_LIST }
    ]
    if (!props.isNational) {
      magasin = magasin.concat([
        { type: "link", title: "Village des services", href: FooterCodes.SERVICES_VILLAGE }])
    }
    return magasin
  });
  const informations = computed(() => {
    let informations = [
      { type: "link", title: "Conditions générales d'utilisation du compte client internet", href: FooterCodes.CUSTOMER_ACCOUNT_TERMS },
      { type: "link", title: "Conditions générales de vente cora.fr et de l’appli coradrive", href: FooterCodes.CGV_INTRERNET },
      { type: "link", title: "Conditions générales de vente traiteur de fêtes", href: FooterCodes.CC_TRAITEUR_FETE_TERMS },
      { type: "link", title: "Conditions générales de vente Drive Services pro", href: FooterCodes.DRIVEPRO_TERMS },
      { type: "link", title: "Conditions générales de vente Produits non accessibles à la vente en libre service", href: FooterCodes.GENERAL_CONDITIONS_OF_UNACCESIBLE_PRODUCTS, target: "_blank" }
    ]
    if (!props.isNational) {
      informations.push({ type: "link", title: "Infos spécifiques", href: FooterCodes.SPECEFIC_INFOS })
    }
    if (props.eligibleLad) {
      informations.push({ type: "link", title: "Conditions générales de l'abonnement livraison", href: FooterCodes.SPOTILAD_TERMS })
    }
    if(!props.isFidCarrefour) {
      informations.push({ type: "link", title: "Conditions générales du programme de fidélité cora", href: FooterCodes.LOAYALTY_PROGRAM_TERMS })
    }
    informations = informations.concat([
      { type: "link", title: "Conditions générales d’utilisation des Cartes Cadeaux Cora", href: FooterCodes.CGU_CARTES_CADEAUX },
      { type: "link", title: "Formulaire de rétractation", href: FooterCodes.RETRACTATION_FORM },
      { type: "link", title: "Information sur la médiation", href: FooterCodes.MEDIATION_INFOS },
      { type: "link", title: "Accessibilité : non conforme", href: FooterCodes.ACCESIBILITY },
      { type: "link", title: "Information escroqueries", href: FooterCodes.SCAMS_INFOS },
      { type: "link", title: "Mangerbouger.fr", href: "https://www.mangerbouger.fr/", target: "_blank" }
    ])
    return informations
  });
  const siteCora = computed(() => {
    const sites = [
      { type: "link", title: "Photos", href: "http://www.coraphotos.fr/", target: "_blank" },
      { type: "link", title: "Carrefour Spectacles", href: "https://spectacles.carrefour.fr/fr", target: "_blank" },
      { type: "link", title: "Prime énergie", href: "https://www.prime-energie-cora.fr/", target: "_blank" },
      { type: "link", title: "Numérisation", href: "https://numerisation.carrefour.fr/fr/accueil", target: "_blank" }

    ]
    if (useRuntimeConfig().public.LOKKI_MAGASINS.includes(props.shopId)) {
      sites.splice(1, 0, { type: "link", title: "Cora Location", href: `https://${props.webAlias}.location.cora.fr`, target: "_blank" })
    }
    return sites
  });

  const openStoreLocator = (link) => {
    context.emit('openStoreLocator', link)
  }

  return {
    aide,
    fidelite,
    responsable,
    donneesPersonnelle,
    servicePro,
    serviceLivraison,
    rappelProduit,
    showBanners,
    magasin,
    informations,
    siteCora,
    openStoreLocator
  }
}